export default "__VITE_ASSET__DzM3oXAz__"